import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle.min";
import 'select2/dist/js/select2.min.js';
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from "redux-persist/integration/react";
import { HelmetProvider } from 'react-helmet-async';
import { store, persistor } from "./redux/store";
import { Provider } from 'react-redux';
import "./index.scss";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root")); // ✅ Correct way

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>            
                <HelmetProvider>    
                    <App />
                </HelmetProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>
    );
reportWebVitals();
